import { render, staticRenderFns } from "./DistrictVue.vue?vue&type=template&id=04c1b162&"
import script from "./DistrictVue.vue?vue&type=script&lang=js&"
export * from "./DistrictVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports